import { compose } from "redux";
import { connect } from "react-redux";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ClearIcon from "@material-ui/icons/Clear";
import Fab from '@material-ui/core/Fab';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import FormHelperText from '@material-ui/core/FormHelperText';
// import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid'
import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
// import RadioButton from '@material-ui/core/Radio';
// import RadioButtonGroup from '@material-ui/core/RadioGroup';
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
// import { registration } from "../actions/SessionAction";
import { teamMemberAdd, updateTeamMember } from "../actions/TeamAction";
import { ATTACHMENT_END_POINT } from "../helpers/constants";
import notfound from '../assets/notfound.png';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';

const CustomTableCell = withStyles(theme => ({
    head: {
        // backgroundColor: "#6128be",
        // color: theme.palette.common.white,
        color: "#2926ac",
        fontWeight: "bold",
        fontSize: 13,
        padding: "3px",

    },
    body: {
        fontSize: 14,
        padding: "3px",
    },
}))(TableCell);

const { innerWidth } = window;

function getModalStyle() {
    return {
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
    };
}

const styles = theme => ({
    root: {
        float: 'right',
    },
    paper: {
        position: 'absolute',
        width: innerWidth >= 480 ? theme.spacing.unit * 100 : (innerWidth - (theme.spacing.unit * 2)),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: innerWidth >= 480 ? theme.spacing.unit * 4 : theme.spacing.unit * 2,
        outline: 'none',
        borderRadius: 5

    },
    margin: {
        margin: theme.spacing.unit,
    },
    closeButtonFab: {
        float: 'right',
        marginRight: innerWidth >= 480 ? '-54px' : '-34px',
        marginTop: innerWidth >= 480 ? '-54px' : '-44px'
    },
    gradientButton: {
        float: 'right',
        marginTop: '-50px',
        background: '#2cc676',
        '&:focus': {
            background: '#27ad67'
        },
        '&:hover': {
            background: '#27ad67'
        },
        '&:active': {
            background: '#27ad67'
        }
    },
    gradientButton1: {
        background: '#2cc676',
        '&:focus': {
            background: '#27ad67'
        },
        '&:hover': {
            background: '#27ad67'
        },
        '&:active': {
            background: '#27ad67'
        }
    },
    backGrd: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        height: 20
    },
    cancelbutton: {
        margin: theme.spacing.unit,
    },
    button: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        color: 'white'
    },
    textField: {
        // width: 350,
        marginTop: -8,
        marginLeft: 8
    },
    input: {
        display: "none"
    },
    inputStyle: {
        padding: '12px 1px',
        fontSize: 14,
        color: 'rgba(0, 0, 0, 0.87)',
    },
    labelRoot: {
        fontSize: '1.3rem'
    },
    chip: {
        margin: theme.spacing.unit,
        border: 'none',
        // flexWrap: 'wrap',
    },
    table: {
        overflowX: "Auto" 
    }
});

class TeamMember extends React.Component {
    state = {
        open: false,
        team_name: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        address_line1: '',
        address_line2: '',
        city: '',
        state: '',
        country: '',
        zipcode: '',
        team_name_error: false,
        first_name_error: false,
        last_name_error: false,
        email_error: false,
        status_error: false,
        email_invalid_error: false,
        phone_error:false,
        zipcode_error:false,
        team_id: null,
        status: "ACTIVE",
        member_image: null,
        selected_member_image_name: "",
        id: null,
        mode: ""
    };

    componentDidMount() {
        let team_id = this.props.team_id;
        this.setState({ team_id: team_id });
    }

    handleOpen = (id, mode) => {
        this.setState({ open: true, mode: mode });
        let teamMember = this.props.teamMembers.length > 0 ? this.props.teamMembers.filter(member => member.id === id) : []
        let Member = teamMember.length > 0 ? teamMember[0] : null
        if (mode === "EDIT") {
            this.setState({
                first_name: mode === "EDIT" ? Member.first_name : "",
                last_name: mode === "EDIT" ? Member.last_name : "",
                email: mode === "EDIT" ? Member.email : "",
                phone: mode === "EDIT" ? Member.phone : null,
                address_line1: mode === "EDIT" ? Member.address_line1 : "",
                address_line2: mode === "EDIT" ? Member.address_line2 : "",
                city: mode === "EDIT" ? Member.city : "",
                state: mode === "EDIT" ? Member.state : "",
                country: mode === "EDIT" ? Member.country : "",
                zipcode: mode === "EDIT" ? Member.zipcode : null,
                status: mode === "EDIT" ? Member.status : "",
                id: mode === "EDIT" ? id : null,
            })
        }
    };

    handleClose = () => {
        this.setState({
            open: false,
            team_name: '',
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            address_line1: '',
            address_line2: '',
            city: '',
            state: '',
            country: '',
            zipcode: '',
            status: '',
            team_name_error: false,
            first_name_error: false,
            last_name_error: false,
            email_error: false,
            phone_error:false,
            zipcode_error:false,
            status_error: false,
            email_invalid_error: false,
            member_image: null,
            selected_member_image_name: "",
            id: null
        });

    };

    // addNewDepartment = () => {
    //     this.handleOpen("ADD", null)
    // }

    validateEmail(email) {
        var re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
    memberImage = ({ target }) => {
        this.setState({ member_image: target.files[0], selected_member_image_name: target.files[0].name });
    };
    validatePhone(phone) {
		var re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\\./0-9]*$/
		return re.test(phone);
     }
     validateZipcode(zipcode) {
        var re = /^([A-Za-z]{2}\s\d{5})$|^(\d{5})$|^([a-zA-Z]{2}-\d{5})$/
		return re.test(zipcode);
     }

    submitForm = () => {
        // alert("Are u want to Register")
        let isError = false;


        if (this.state.first_name === "") {
            this.setState({ first_name_error: true })
            isError = true
        }
        if (this.state.last_name === "") {
            this.setState({ last_name_error: true })
            isError = true
        }
        if (this.state.email !== null && this.state.email !== "") {
            if (!this.validateEmail(this.state.email) === true) {
                this.setState({ email_invalid_error: true })
                isError = true
            }
        }
        if(this.state.phone !== ""){
            if (this.state.phone.length >= 10 ) {
                if (!this.validatePhone(this.state.phone) === true) {
                this.setState({ phone_error: true });
                isError = true
            }
            }
            else {
                this.setState({ phone_error: true });
                isError = true  
            }
        }
        	
		if(this.state.zipcode !== ""){
           
			if (this.state.zipcode.length >=5 ) {
                if (!this.validateZipcode(this.state.zipcode) === true) {
                this.setState({ zipcode_error: true });
                isError = true
            }
            }
            else {
                this.setState({ zipcode_error: true });
                isError = true  
            }
        }

        if (isError === false) {
            if (this.state.mode === "ADD") {
                // alert(JSON.stringify(this.state))
                this.props.dispatch(teamMemberAdd(this, this.state))
            }
            else {
                this.props.dispatch(updateTeamMember(this, this.state))
            }
            this.setState({
                open: false,
                team_name: '',
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                address_line1: '',
                address_line2: '',
                city: '',
                state: '',
                country: '',
                zipcode: '',
                status: '',
                team_name_error: false,
                first_name_error: false,
                last_name_error: false,
                email_error: false,
                phone_error:false,
                zipcode_error:false,
                status_error: false,
                email_invalid_error: false,
                member_image: null,
                selected_member_image_name: "",
                id: null
            })
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <div >
                <Button variant="contained" color="secondary" size="small" className={classes.gradientButton} onClick={() => this.handleOpen(null, "ADD")}> ADD TEAM MEMBER</Button>
                <div className={classes.table} style={{ marginTop: 50 }}>
                    <Table >
                        <TableHead>
                            <TableRow>
                                {/* <CustomTableCell></CustomTableCell> */}
                                <CustomTableCell >Name</CustomTableCell>
                                <CustomTableCell align="left">Email</CustomTableCell>
                                <CustomTableCell align="left">Contact Number</CustomTableCell>
                                <CustomTableCell align="left">Action</CustomTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.props.teamMembers.length > 0 ?
                                this.props.teamMembers.map(teamMember =>
                                    <TableRow className={classes.row} >
                                        {/* <CustomTableCell >
                                    <Avatar alt="Remy Sharp" src={teamMember.attachments.length > 0 ? `${ATTACHMENT_END_POINT}${teamMember.attachments[0].file_name}` : notfound } className={classes.avatar} />
                                </CustomTableCell> */}
                                        <CustomTableCell>
                                            <Chip
                                                avatar={
                                                    <Avatar alt="Remy Sharp" src={teamMember.attachments.length > 0 ? `${ATTACHMENT_END_POINT}${teamMember.attachments[0].file_name}` : notfound} />
                                                }
                                                label={`${teamMember.first_name} ${teamMember.last_name}`}
                                                className={classes.chip}
                                                variant="outlined"
                                            />
                                        </CustomTableCell>
                                        <CustomTableCell align="left">{teamMember.email}</CustomTableCell>
                                        <CustomTableCell align="left">{teamMember.phone}</CustomTableCell>
                                        <CustomTableCell align="left">
                                            <Button variant="contained" color="secondary" size="small" onClick={() => this.handleOpen(teamMember.id, "EDIT")}> EDIT</Button>
                                        </CustomTableCell>
                                    </TableRow>)
                                : null}
                        </TableBody>
                    </Table>
                </div>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.open}
                    onClose={this.handleClose}
                    disableBackdropClick={true}
                >
                    <div style={getModalStyle()} className={classes.paper}>
                        <div className={classes.closeButtonFab}>
                            <Fab size="small" color="secondary" aria-label="Add" className={classes.margin} onClick={this.handleClose}>
                                <ClearIcon />
                            </Fab>
                        </div>
                        <Typography variant="h6" style={{ marginBottom: 20 }} >
                            {this.state.mode === "ADD" ? "Add Team Member" : "Edit Team Member"}
                        </Typography>
                        <Grid container spacing={8}>

                            <Grid item xs={6} >
                                <TextField
                                    id="standard-name"
                                    label="First Name"
                                    fullWidth
                                    className={classes.textField}
                                    required
                                    error={this.state.first_name_error === true ? true : false}
                                    helperText={this.state.first_name_error === true ? "Please Enter First Name" : false}
                                    value={this.state.first_name || ""}
                                    onChange={(event) => this.setState({ first_name: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1), first_name_error: false })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <TextField
                                    id="standard-name"
                                    label="Last Name"
                                    fullWidth
                                    className={classes.textField}
                                    required
                                    error={this.state.last_name_error === true ? true : false}
                                    helperText={this.state.last_name_error === true ? "Please Enter Last Name" : false}
                                    value={this.state.last_name || ""}
                                    onChange={(event) => this.setState({ last_name: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1), last_name_error: false })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <TextField
                                    id="standard-name"
                                    label="Email"
                                    fullWidth
                                    className={classes.textField}
                                    // required
                                    error={this.state.email_invalid_error === true ? true : false}
                                    helperText={this.state.email_invalid_error === true ? "Please enter valid email" : null}
                                    value={this.state.email || ""}
                                    onChange={(event) => this.setState({ email: event.target.value, email_error: false, email_invalid_error: false })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <TextField
                                    id="standard-name"
                                    label=" Phone"
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.phone || ""}
                                    //onChange={(event) => this.setState({ phone: event.target.value })}
                                    onChange={(event) => this.setState({ phone: event.target.value,phone_error: false })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                    helperText={this.state.phone_error === true ? "Please enter valid phone number" : false}
                                    error={this.state.phone_error === true ? true : false}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <TextField
                                    id="standard-name"
                                    label="Address Line1"
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.address_line1 || ""}
                                    onChange={(event) => this.setState({ address_line1: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1) })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <TextField
                                    id="standard-name"
                                    label="Address Line2"
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.address_line2 || ""}
                                    onChange={(event) => this.setState({ address_line2: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1) })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <TextField
                                    id="standard-name"
                                    label=" City"
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.city || ""}
                                    onChange={(event) => this.setState({ city: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1) })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <TextField
                                    id="standard-name"
                                    label="State"
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.state || ""}
                                    onChange={(event) => this.setState({ state: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1) })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <TextField
                                    id="standard-name"
                                    label="Country"
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.country || ""}
                                    onChange={(event) => this.setState({ country: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1) })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <TextField
                                    id="standard-name"
                                    label="Zipcode"
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.zipcode || ""}
                                    onChange={(event) => this.setState({ zipcode: event.target.value,zipcode_error: false })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                    helperText={this.state.zipcode_error === true ? "Please enter valid Zipcode " : false}
                                    error={this.state.zipcode_error === true ? true : false}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <input
                                    accept="image/*"
                                    className={classes.input}
                                    id="contained-button-file"
                                    type="file"
                                    onChange={this.memberImage}
                                />
                                <label htmlFor="contained-button-file">
                                    <Button variant="outlined" component="span" className={classes.gradientButton1}>
                                        Upload member image
                            <CloudUploadIcon className={classes.rightIcon} />
                                    </Button>
                                </label>
                                <Typography>{this.state.selected_member_image_name}</Typography>
                            </Grid>
                            {/* <Grid item xs={6} >
                            <TextField
                                id="standard-name"
                                label="Status"
                                fullWidth
                                className={classes.textField}
                                required
                                error={this.state.status_error === true ? true : false}
                                helperText={this.state.status_error === true ? "Please Enter  status" : false}
                                value={this.state.status || ""}
                                onChange={(event) => this.setState({ status: event.target.value, status_error: false })}
                                margin="normal"
                                InputProps={{ classes: { input: classes.inputStyle } }}
                                InputLabelProps={{
                                    shrink: true,
                                    FormLabelClasses: {
                                        root: classes.labelRoot
                                    }
                                }}
                            />
                        </Grid> */}
                            <Grid item xs={12} >
                                <div style={{ textAlign: "center" }}>
                                    <Button onClick={this.handleClose} variant="contained" color="secondary" size="small" className={classes.cancelbutton}>
                                        cancel
                                    </Button>
                                    <Button onClick={this.submitForm} variant="contained" size="small" className={classes.button}>
                                        Submit
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </div>

                </Modal>
            </div>
        );
    }
}

TeamMember.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        myTeam: state.TeamReducer.myTeam,
        teamMembers: state.TeamReducer.teamMembers,

    }
}

export default compose(withStyles(styles), connect(mapStateToProps))(TeamMember);